export default "__VITE_ASSET__B4E8mbSo__"